import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import blueLogo from '../../assets/blue-logo.png'
import '@ant-design/compatible/assets/index.css'
import '../Platform/Shared/Setup/AccountSetup.scss'
import './Signup.scss'
import { isBrowserBad } from '../../helpers/crossBrowser'

class Signup extends Component {
  render() {
    return (
        <div className={`signupPage${isBrowserBad ? ' bad-browser-setup' : ''}`}>
            <div className='signup-navbar'>
                <img src={blueLogo} alt='Reggora Logo'/>
            </div>

            <div className='signup' id={isBrowserBad ? 'accountSetup' : ''}>
                <div>
                    <div className='signup-header'>
                        <div className='signup-sub'>Already have an account? <Link to='/login'>Log in</Link></div>
                    </div>
                    <div className='signup-body'>
                        <span>Your invite link has expired. Please contact&nbsp;</span>
                        <a href='mailto:appraisal@reggora.com'>appraisal@reggora.com</a>
                        <span>&nbsp;to get a new registration link.</span>
                    </div>
                </div>
            </div>
        </div>)
  }
}

export default Signup
